import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { GlobalHeader } from '../components/GlobalHeader/GlobalHeader';
import { Head } from '../components/Head/Head';

import { IwiAffiliationFormBehalfOf } from '@/features/iwiAffiliationFormBehalfOf';

const BehalfOfForm = () => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}>
    <Head />

    <GlobalHeader variantOverride="dark" />

    <main>
      <IwiAffiliationFormBehalfOf />
    </main>
  </GoogleReCaptchaProvider>
);
export default BehalfOfForm;
